// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* NORYX theme: replace black with dark green (buttons, modals, dark boxes) */
:root {
  --noryx-green: #14532d;
  --noryx-green-hover: #0e3f22;
  --noryx-green-active: #0a2f19;
}

.btn-dark,
.btn.bg-black,
.btn.bg-dark {
  background-color: var(--noryx-green) !important;
  border-color: var(--noryx-green) !important;
  color: #fff !important;
}
.btn-dark:hover,
.btn.bg-black:hover,
.btn.bg-dark:hover {
  background-color: var(--noryx-green-hover) !important;
  border-color: var(--noryx-green-hover) !important;
}
.btn-dark:focus,
.btn-dark:active,
.btn-dark:not(:disabled):not(.disabled):active {
  background-color: var(--noryx-green-active) !important;
  border-color: var(--noryx-green-active) !important;
  box-shadow: 0 0 0 0.2rem rgba(20, 83, 45, 0.35) !important;
}
.btn-dark:disabled,
.btn-dark.disabled {
  opacity: 0.55;
}
.btn-outline-dark {
  color: var(--noryx-green);
  border-color: var(--noryx-green);
}
.btn-outline-dark:hover {
  background-color: var(--noryx-green);
  border-color: var(--noryx-green);
  color: #fff;
}

/* Modals */
.modal-header.bg-black,
.modal-header.bg-dark,
.modal-header {
  background-color: var(--noryx-green) !important;
  color: #fff;
}
.modal-header .close,
.modal-header .btn-close {
  color: #fff;
  opacity: 0.85;
  text-shadow: none;
}

/* Other dark backgrounds */
.bg-black,
.bg-dark {
  background-color: var(--noryx-green) !important;
}
`, "",{"version":3,"sources":["webpack://./src/theme-noryx.css"],"names":[],"mappings":"AAAA,6EAA6E;AAC7E;EACE,sBAAsB;EACtB,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;;;EAGE,+CAA+C;EAC/C,2CAA2C;EAC3C,sBAAsB;AACxB;AACA;;;EAGE,qDAAqD;EACrD,iDAAiD;AACnD;AACA;;;EAGE,sDAAsD;EACtD,kDAAkD;EAClD,0DAA0D;AAC5D;AACA;;EAEE,aAAa;AACf;AACA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;AACA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,WAAW;AACb;;AAEA,WAAW;AACX;;;EAGE,+CAA+C;EAC/C,WAAW;AACb;AACA;;EAEE,WAAW;EACX,aAAa;EACb,iBAAiB;AACnB;;AAEA,2BAA2B;AAC3B;;EAEE,+CAA+C;AACjD","sourcesContent":["/* NORYX theme: replace black with dark green (buttons, modals, dark boxes) */\n:root {\n  --noryx-green: #14532d;\n  --noryx-green-hover: #0e3f22;\n  --noryx-green-active: #0a2f19;\n}\n\n.btn-dark,\n.btn.bg-black,\n.btn.bg-dark {\n  background-color: var(--noryx-green) !important;\n  border-color: var(--noryx-green) !important;\n  color: #fff !important;\n}\n.btn-dark:hover,\n.btn.bg-black:hover,\n.btn.bg-dark:hover {\n  background-color: var(--noryx-green-hover) !important;\n  border-color: var(--noryx-green-hover) !important;\n}\n.btn-dark:focus,\n.btn-dark:active,\n.btn-dark:not(:disabled):not(.disabled):active {\n  background-color: var(--noryx-green-active) !important;\n  border-color: var(--noryx-green-active) !important;\n  box-shadow: 0 0 0 0.2rem rgba(20, 83, 45, 0.35) !important;\n}\n.btn-dark:disabled,\n.btn-dark.disabled {\n  opacity: 0.55;\n}\n.btn-outline-dark {\n  color: var(--noryx-green);\n  border-color: var(--noryx-green);\n}\n.btn-outline-dark:hover {\n  background-color: var(--noryx-green);\n  border-color: var(--noryx-green);\n  color: #fff;\n}\n\n/* Modals */\n.modal-header.bg-black,\n.modal-header.bg-dark,\n.modal-header {\n  background-color: var(--noryx-green) !important;\n  color: #fff;\n}\n.modal-header .close,\n.modal-header .btn-close {\n  color: #fff;\n  opacity: 0.85;\n  text-shadow: none;\n}\n\n/* Other dark backgrounds */\n.bg-black,\n.bg-dark {\n  background-color: var(--noryx-green) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
